module.exports = __webpack_public_path__ + "4a0f98861713ac39a38b0322d60944fa.png";